export default {
  default: () => import("/builds/common/airbaltic-com/company/layouts/default.vue").then(m => m.default || m),
  full: () => import("/builds/common/airbaltic-com/company/layouts/full.vue").then(m => m.default || m),
  "index-page": () => import("/builds/common/airbaltic-com/company/layouts/index-page.vue").then(m => m.default || m),
  "page-default": () => import("/builds/common/airbaltic-com/company/layouts/page/default.vue").then(m => m.default || m),
  "page-section": () => import("/builds/common/airbaltic-com/company/layouts/page/section.vue").then(m => m.default || m)
}